module.exports = __webpack_public_path__ + "img/login-title.a44c779c.png";